export const N77_05 = {
    "columns": 5,
    "rows": 1,
    "visual": {
        "id": 1,
        "type": "bar",
        "title": "Aging General Summary",
        "colorTheme": 'colorTheme1',
        "orientation": "vertical",
        "xAxis": "",
        "yAxis": "",
        "binding": {
            "data": {
                "series": [
                    {
                        "name": 'Not Due',
                        "value": 'NotYetDue',
                        "type": 'column'
                    },
                    {
                        "name": 'Current',
                        "value": 'Current',
                        "type": 'column'
                    },
                    {
                        "name": '1- 30',
                        "value": '1Month',
                        "type": 'column'
                    },
                    {
                        "name": '31 - 60',
                        "value": '2Months',
                        "type": 'column'
                    },
                    {
                        "name": '61 - 90',
                        "value": '3Months',
                        "type": 'column'
                    },
                    {
                        "name": '91 - 120',
                        "value": '4Months',
                        "type": 'column'
                    },
                    {
                        "name": '121 - 150',
                        "value": '5Months',
                        "type": 'column'
                    },
                    {
                        "name": '151 + days',
                        "value": '6MonthsOver',
                        "type": 'column'
                    }
                ],
                "title": "Category",
                "endpoint": "N77.5",
                "parameters": [
                    { "key": "FromMonth", "value": "" },
                    { "key": "FromYear", "value": "" },
                    { "key": "ToMonth", "value": "" },
                    { "key": "ToYear", "value": "" },
                    { "key": "ConfigTypeCode", "value": "" }
                ]
            },
            "context": {
                "point": {
                    "onClick": {}
                }
            }
        }
    }
}